import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthorizedDistributors from "../components/AuthorizedDistributors";
import CardSelector from "../components/CardSelector/CardSelector";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import Loader from "../components/Loader/Loader";
import OurProjects from "../components/OurProjects/OurProjects";
import Services from "../components/Services/Services";
import Meta from "../components/Meta";

function Home({ openNav }) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Meta
        title="VITRI ENTERPRISES"
        description="VITRI ENTERPRISES is a leading provider of CCTV, video door phones, EPABX, boom barriers, access control, and networking solutions in Gujarat. Secure your home or business with us."
        keywords="CCTV installation, video door phone, EPABX systems, boom barrier, access control, networking Gujarat, security systems provider"
        canonical="https://vitrienterprises.in/"
      />
      <>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="sticky-header">
              <Header openNav={openNav} />
            </div>
            <div>
              <CardSelector />
            </div>
            <section className="about_section layout_padding-bottom">
              <div className="square-box">
                <img
                  src="https://res.cloudinary.com/ddffnw81j/image/upload/v1737007384/square_fkb3km.png"
                  alt=""
                  className="background-pattern"
                />
              </div>
              <div className="container" style={{ marginTop: "2rem" }}>
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="img-box">
                      <img
                        src="images/home-1.jpg"
                        alt="About Katha"
                        className="about-image"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="detail-box">
                      <div className="heading_container">
                        <h2 className="section-title">
                          Vitri Enterprises : <br />
                        </h2>
                      </div>
                      <p className="about-description">
                        Vitri Enterprises offers a wide range of advanced
                        security and office automation solutions, including CCTV
                        Camera Systems, EPABX, Video Door Phones, Fire Alarm
                        Systems, Home Automation and other cutting-edge products designed to
                        make your life more secure and convenient. Since our
                        establishment in 2011, we have grown to become a trusted
                        distributor and wholesaler in the industry through our
                        unwavering commitment to quality and customer
                        satisfaction. <br />
                        Our mission is to provide reliable, innovative solutions
                        that enhance safety and efficiency. To achieve this, we
                        collaborate with renowned manufacturers and business
                        partners who share our dedication to excellence. <br />
                        {/* At Vitri Enterprises, we take pride in setting industry
                        benchmarks for quality, professionalism, and
                        customer-centricity. Our relentless pursuit of
                        innovation and excellence continues to drive our growth
                        and success, making us a preferred partner for security
                        and office automation needs. Let me know if you'd like
                        to tailor this further or include any specific details! */}
                      </p>
                      <div
                        onClick={() => navigate("/about")}
                        className="btn-find-more"
                      >
                        Explore More
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <Services />
            <AuthorizedDistributors />
            <OurProjects />
            <div
              className="gt-btn-div"
              style={{ paddingBottom: "2rem", paddingTop: "2rem" }}
            >
              <button
                className="learn-more"
                aria-label="Get in touch"
                onClick={() => navigate("/contact")}
              >
                <span className="circle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Get in Touch</span>
              </button>
            </div>
            <Footer />
          </>
        )}
      </>
    </div>
  );
}

export default Home;
